import { useContext, useState } from 'react';
import { FormikHelpers } from 'formik';
import AuthContext from '../../../AppContext/AuthProvider';
import { AUTH_ERRORS } from '../../../Constants/ErrorMessages';
import useAsyncTask from '../../../hooks/useAsyncTask';
import useErrorHandlers from '../../../hooks/useErrorHandlers';
import { logger } from '../../../utils';
import { ForgotPasswordFormData } from '../../../models/auth';
import { TForgotPasswordStates } from '../@types';

function useForgotPasswordActions() {
  const [state, setState] = useState<TForgotPasswordStates>('forgot-password-form');

  const { forgotPassword } = useContext(AuthContext);
  const { handleError } = useErrorHandlers();

  const handleResetPassword = useAsyncTask<{
    values: Partial<ForgotPasswordFormData>;
    formikHelpers: FormikHelpers<Partial<ForgotPasswordFormData>>;
  }>(async data => {
    const { values, formikHelpers } = data;
    try {
      if (!values.email) return;
      await forgotPassword(values.email);
      formikHelpers.resetForm();
      setState('thank-you');
      window.scroll({ top: 0 });
    } catch (error: any) {
      if (error?.response?.data?.responseCode === AUTH_ERRORS.EMAIL_NOT_VERIFIED) {
        handleError({
          code: AUTH_ERRORS.EMAIL_NOT_VERIFIED,
          metaData: values?.email,
        });
        return;
      }
      logger.error(error);
    }
  });

  return {
    state,
    handleResetPassword,
  };
}

export default useForgotPasswordActions;
